import React, { useState, useEffect, Fragment } from "react";
import {
  getDictationMessages,
  updateDictationHoldMessage,
} from "apiHandler/actions/scribe";
import { useUserData } from "components/customHooks/userDataContext";
import { LinearProgress, Modal, Skeleton } from "@mui/material";

const prevTable = [
  { label: "User Type", value: "user_type", width: "15%" },
  { label: "User", value: "user", width: "30%" },
  { label: "Message", value: "message", width: "55%" },
];

const DictationOnHold = ({
  onClose,
  dictation_id,
  details,
  setDetails,
  previous,
  setPrevious,
  onHold,
}) => {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const userData = useUserData();
  const token = userData?.access_token;

  useEffect(() => {
    const fetchMessages = async () => {
      const payload = {
        type: "Scribe",
        search_criteria: {
          scribe_id: userData.email,
          dictation_id: dictation_id,
        },
      };
      const result = await getDictationMessages(payload, token);
      if (result && result !== "ERROR") setPrevious(result);
      else {
        setError("Failed to get previous messages");
        setPrevious([]);
      }
    };
    fetchMessages();
  }, []);

  const onSubmit = async () => {
    const payload = {
      type: "Scribe",
      search_criteria: {
        scribe_id: userData.email,
        dictation_id: dictation_id,
        status: "On-Hold",
        message: message,
      },
    };
    await setLoading(true);
    const result = await updateDictationHoldMessage(payload, token);
    await setLoading(false);
    if (!result || result === "ERROR") setError("Failed to change the status");
    else {
      setDetails({ ...details, status: "On-Hold" });
      onClose();
    }
  };

  return (
    <Modal onClose={onClose} open={true}>
      <div className="dictation-common-modal">
        <h4 className="dcm-title">
          {onHold ? "Messages" : "Change Status To On-Hold"}
        </h4>
        <p className="dohm-error">{error}</p>
        {loading && <LinearProgress color="secondary" />}
        <div className="dcm-status">
          {previous === null ? (
            <div>
              <Skeleton variant="text" height={50} />
              <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
              <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
              <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
              <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
              <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
            </div>
          ) : (
            <table className="dcm-table">
              <thead>
                <tr>
                  {prevTable.map((th) => (
                    <th
                      className="dcm-th"
                      style={{ width: th.width }}
                      key={th.label}
                    >
                      {th.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {previous?.length !== 0 ? (
                  previous.map((m) => (
                    <tr className="dcm-tr" key={m.id}>
                      {prevTable.map((th) => (
                        <td className="dcm-td" key={th.label}>
                          {m[th.value]}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} style={{ textAlign: "center" }}>
                      {" "}
                      No Messages Available{" "}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
        {onHold || (
          <Fragment>
            <div className="dcm-comment">
              Add Message
              <textarea
                className="dcm-textarea"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
            <div className="dcm-btn-cont">
              <button className="dcm-save" onClick={onSubmit}>
                Submit
              </button>
              <button className="dcm-cancel" onClick={onClose}>
                Cancel
              </button>
            </div>
          </Fragment>
        )}
      </div>
    </Modal>
  );
};

export default DictationOnHold;
